import DeleteIcon from '@/App/tiles/ForwardAccumulator/parts/RightPanel/Scheduler/Table/DeleteIcon.tsx';
import Eki from '@/App/tiles/ForwardAccumulator/parts/RightPanel/Scheduler/Table/Eki';
import FixingDate from '@/App/tiles/ForwardAccumulator/parts/RightPanel/Scheduler/Table/FixingDate.tsx';
import PaymentDate from '@/App/tiles/ForwardAccumulator/parts/RightPanel/Scheduler/Table/PaymentDate.tsx';
import { ReadOnlyCellRenderer } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/Scheduler/Table/ReadOnlyCellRenderer.tsx';
import type { SchedulerCalendarProperty } from '@/store/forwardAccumulator/utils.ts';

const DataCellRenderer = ({ property, legId }: { property: SchedulerCalendarProperty; legId: string }) => {
  switch (property) {
    case 'fixingDate':
      return <FixingDate legId={legId} />;
    case 'paymentDate':
      return <PaymentDate legId={legId} />;
    case 'deleteIcon':
      return <DeleteIcon legId={legId} />;
    case 'EKI':
      return <Eki legId={legId} />;
    case 'strike': // no brk
    case 'step':
      return <ReadOnlyCellRenderer legId={legId} property={property} />;
    case 'amount': // no brk
    case 'leverageAmount':
      return <ReadOnlyCellRenderer isAmount legId={legId} property={property} />;
    default:
      return null;
  }
};

export default DataCellRenderer;
